<template>
  <div>
    <div class="flex-row row">
      <div class="flex-col col-xs-12 col-sm-4">
        <strong class="text-nowrap">Flock ID</strong>
      </div>
      <div class="flex-col col-xs-12 col-sm-8 text-normal">
        {{ flock.id }}
      </div>
    </div>

    <div v-if="checkPremise" class="flex-row row" style="margin-top: .75em;">
      <div class="flex-col col-xs-12 col-sm-4">
        <strong class="">Premise ID</strong>
      </div>
      <div class="flex-col col-xs-12 col-sm-8 text-normal">
        {{ flock.premise_id }}
      </div>
    </div>

    <div class="flex-row row" style="margin-top: .75em;">
      <div class="flex-col col-xs-12 col-sm-4">
        <strong>Address</strong>
      </div>
      <div class="flex-col col-xs-12 col-sm-8 text-normal">
        <div class="leading-tight">
          {{ flock.address.first_name }} {{ flock.address.last_name }}<br>
          {{ flock.address.street }}<br>
          {{ flock.address.city }}, {{ flock.address.state }} {{ flock.address.zip }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    checkPremise: {
      default: false,
      type: Boolean,
    },
    flock: {
      type: Object,
      default: () => {
        return {
          id: '',
          premise_id: '',
          address: {
            first_name: '',
            last_name: '',
            street: '',
            city: '',
            state: '',
            zip: '',
          },
          confirm: false,
        };
      },
    },
  },
}
</script>
